import { getABNVariant } from '~/src/helpers/abn-tests';

const isAdditionalEquipment = () => {
    return getABNVariant('additional_equipment') === 'additional_equipment_on';
};

export default isAdditionalEquipment;
